import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileCompletionCard = ({ completionPercentage }) => {
  const getCompletionColor = (percentage) => {
    if (percentage >= 80) return 'success';
    if (percentage >= 50) return 'warning';
    return 'error';
  };

  const completionColor = getCompletionColor(completionPercentage);

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Profile Completion</h3>
          <p className="text-sm text-muted-foreground">Complete your profile to unlock all features</p>
        </div>
        <div className={`w-12 h-12 rounded-full bg-${completionColor}/10 flex items-center justify-center`}>
          <Icon name="User" size={24} color={`var(--color-${completionColor})`} />
        </div>
      </div>
      
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-2xl font-semibold text-foreground">{completionPercentage}%</span>
          <span className={`text-sm font-medium text-${completionColor}`}>
            {completionPercentage >= 80 ? 'Excellent' : completionPercentage >= 50 ? 'Good Progress' : 'Needs Attention'}
          </span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full bg-${completionColor} transition-all duration-500`}
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-3 text-sm">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span className="text-foreground">Company information completed</span>
        </div>
        <div className="flex items-center gap-3 text-sm">
          <Icon name="CheckCircle" size={16} color="var(--color-success)" />
          <span className="text-foreground">Contact details verified</span>
        </div>
        {completionPercentage < 100 && (
          <div className="flex items-center gap-3 text-sm">
            <Icon name="Circle" size={16} className="text-muted-foreground" />
            <span className="text-muted-foreground">Enable two-factor authentication</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileCompletionCard;